import React, { useMemo } from 'react'
import { ExternalSystem, ExternalSystemId } from 'api/Clients/Types/ClientDetailedDto'
import HubSpotImage from 'assets/images/hubspot-crm-icon.png'
import IbkrLogo from 'assets/images/ibkr.png'
import SugarImage from 'assets/images/sugar_crm.jpg'
import SugarOldImage from 'assets/images/sugarcrm-old.png'
import SumsubLogo from 'assets/images/Sumsub.png'
import { Link } from 'components/Link'

interface Props {
  data: ExternalSystem
  key: string | number
  size?: number
}
export const ExternalLink: React.FC<Props> = ({ data, size }) => {
  const getSrc = useMemo(() => {
    if (data.externalSystem.id === ExternalSystemId.SugarCRM) {
      return SugarImage
    }
    if (data.externalSystem.id === ExternalSystemId.HubSpot) {
      return HubSpotImage
    }
    if (data.externalSystem.id === ExternalSystemId.LegacySugarCRM) {
      return SugarOldImage
    }
    if (data.externalSystem.id === ExternalSystemId.Sumsub) {
      return SumsubLogo
    }
    if (data.externalSystem.id === ExternalSystemId.IBKR) {
      return IbkrLogo
    }
    return undefined
  }, [data.externalSystem.id])

  if (!getSrc) {
    return null
  }

  return (
    <Link key={data.id} to={data.externalUrl} target='noopener noreferrer'>
      <img width={size} height={size} key={data.id} alt='externalSystem' src={getSrc} />
    </Link>
  )
}
